var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableGreenPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1682_28721)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 21,
    height: 21,
    rx: 4,
    fill: "#0FCB02"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1682_28721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9922 14.7793V13.0019H11.2148C10.9344 13.0019 10.707 12.7746 10.707 12.4941C10.707 12.2137 10.9344 11.9863 11.2148 11.9863H12.9922V10.209C12.9922 9.92859 13.2195 9.70116 13.5 9.70116C13.7805 9.70116 14.0078 9.92859 14.0078 10.209V11.9863H15.7852C16.0656 11.9863 16.293 12.2137 16.293 12.4941C16.293 12.7746 16.0656 13.0019 15.7852 13.0019H14.0078V14.7793C14.0078 15.0598 13.7805 15.2871 13.5 15.2871C13.2195 15.2871 12.9922 15.0598 12.9922 14.7793ZM18.0962 7.89843C16.8685 6.67075 15.2362 5.99463 13.5 5.99463C11.7638 5.99463 10.1315 6.67075 8.9038 7.89843C7.67612 9.12611 7 10.7584 7 12.4946C7 14.2308 7.67612 15.8632 8.9038 17.0908C10.1315 18.3185 11.7638 18.9946 13.5 18.9946C14.6886 18.9946 15.8516 18.6707 16.8633 18.0579C17.1032 17.9126 17.1799 17.6003 17.0346 17.3605C16.8893 17.1206 16.5769 17.0439 16.3371 17.1892C15.4841 17.7059 14.503 17.979 13.5 17.979C10.4759 17.979 8.01562 15.5187 8.01562 12.4946C8.01562 9.47057 10.4759 7.01025 13.5 7.01025C16.5241 7.01025 18.9844 9.47057 18.9844 12.4946C18.9844 13.576 18.6628 14.6285 18.0544 15.5386C17.8985 15.7717 17.9612 16.0871 18.1944 16.243C18.4275 16.3988 18.7429 16.3362 18.8988 16.1031C19.6191 15.0255 20 13.7776 20 12.4946C20 10.7584 19.3239 9.12611 18.0962 7.89843Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1682_28721",
    x: 0,
    y: 0,
    width: 29,
    height: 29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1682_28721"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1682_28721",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1682_28721"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(7 5.99463)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableGreenPlusIcon);
export default __webpack_public_path__ + "static/media/table-green-plus-icon.7789e82484f4ce59871ac48898e1416d.svg";
export { ForwardRef as ReactComponent };